import { render, staticRenderFns } from "./history-component.vue?vue&type=template&id=61f00b91&scoped=true"
import script from "./history-component.vue?vue&type=script&lang=js"
export * from "./history-component.vue?vue&type=script&lang=js"
import style0 from "./history-component.vue?vue&type=style&index=0&id=61f00b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f00b91",
  null
  
)

export default component.exports